<template>
    <div :class="listClass">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            justify: { type: String, default: undefined },
        },

        computed: {
            listClass() {
                return {
                    list: true,
                    [`list--justify-${this.justify}`]: this.justify,
                }
            },
        },
    }
</script>
